import "@/styles/index.css";

import scrollTo from "@/scripts/components/scroll-to";

import Alpine from "alpinejs";

scrollTo.init();

Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
